/**
 * Route for `proxy-traffic-real-time-db-block`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { ProxyTrafficRealTimeDbBlockPage } from "../features/proxy-traffic-real-time-db-block/ProxyTrafficRealTimeDbBlockPage";

export const proxyTrafficRealTimeDbBlockRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/proxy-traffic-real-time-db-block",
	component: ProxyTrafficRealTimeDbBlockPage,
});

export default proxyTrafficRealTimeDbBlockRoute;
